import type { VisualPayload } from "../../types";
import CardShell from "./_CardShell";

interface Props { payload: VisualPayload }

export default function XLCandyCard({ payload }: Props) {
  const sec = payload.sections.find((s) => s.section === "xl_candy");
  if (!sec) {
    return (
      <CardShell title={payload.title} source={payload.data_source} timestamp={payload.data_timestamp} sourceUrl={payload.source_url} shareUrl={payload.share_url} snapshotPayload={payload.snapshot_eligible ? payload : undefined}>
        <p className="text-sm text-white/40 py-4 text-center">No XL candy data available.</p>
      </CardShell>
    );
  }

  const needsXL = Boolean(sec.needs_xl);
  const level: number | null = sec.best_level != null ? Number(sec.best_level) : null;
  const cp: number | null = sec.best_cp != null ? Number(sec.best_cp) : null;
  const leagueLabel = String(sec.league_label ?? sec.league ?? "this league");

  return (
    <CardShell title={payload.title} source={payload.data_source} timestamp={payload.data_timestamp} sourceUrl={payload.source_url} shareUrl={payload.share_url} snapshotPayload={payload.snapshot_eligible ? payload : undefined}>
      <div className="space-y-4">
        {/* XL verdict pill */}
        <div className="flex items-center gap-3">
          <span
            className={`text-sm font-semibold px-3 py-1.5 rounded-full ${
              needsXL
                ? "bg-amber-500/20 text-amber-400"
                : "bg-green-500/15 text-green-400"
            }`}
          >
            {needsXL ? "XL Candy required" : "No XL Candy needed"}
          </span>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 gap-3">
          <div className="bg-white/[0.05] rounded-lg p-3">
            <p className="text-[10px] uppercase tracking-wide text-white/30 mb-1">Best Level</p>
            <p className="text-xl font-bold text-white">{level != null ? level.toFixed(1) : "—"}</p>
            {needsXL && level != null && (
              <p className="text-[11px] text-amber-400/70 mt-0.5">Requires XL candy above Lv 40</p>
            )}
          </div>
          <div className="bg-white/[0.05] rounded-lg p-3">
            <p className="text-[10px] uppercase tracking-wide text-white/30 mb-1">CP at Best Level</p>
            <p className="text-xl font-bold text-white">{cp != null ? cp.toLocaleString() : "—"}</p>
            <p className="text-[11px] text-white/30 mt-0.5">{leagueLabel}</p>
          </div>
        </div>

        {/* Context note */}
        <p className="text-xs text-white/30 leading-relaxed">
          {needsXL
            ? `${sec.pokemon_name} reaches its optimal PvP level in ${leagueLabel} above level 40, meaning XL candy is needed to hit peak stat product.`
            : `${sec.pokemon_name} reaches its optimal PvP level in ${leagueLabel} at or below level 40 — no XL candy required.`}
        </p>
      </div>
    </CardShell>
  );
}
